// extracted by mini-css-extract-plugin
export default {"Hero":"Hero_Hero__jbqk1","Hero_Image":"Hero_Hero_Image__4bZeJ","zoomIn":"Hero_zoomIn__+RsmL","spinIn":"Hero_spinIn__9o3Pz","heartbeat":"Hero_heartbeat__J3mUX"};